export default string => /[A-Za-z]/.test(string)
